import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const usePagePermission = () => {
    const { pathname } = useLocation();

    const urlMap = useSelector((state) => state.sidebarNavigation.urlMap);
    const permMap = useSelector(
        (state) => state.rolePermissions.navigationUserMap,
    );

    const denied = {
        canCreate: false,
        canModify: false,
        canDelete: false,
        canView: false,
        canPrint: false,
        canMail: false,
    };

    const currentPath = pathname.split("?")[0].replace(/\/+$/, "") || "/";

    const navEntry = urlMap[currentPath];
    if (!navEntry) return denied;

    const entry = permMap[`${navEntry.type}:${navEntry.id}`] || {};

    // console.log("Current Path:", pathname);
    // console.log("Navigation Entry:", navEntry);
    // console.log("Permission Key:", `${navEntry.type}:${navEntry.id}`);
    // console.log("Permission Entry:", entry);

    return {
        canCreate: entry.create === true,
        canModify: entry.modify === true,
        canDelete: entry.delete === true,
        canView: entry.view === true,
        canPrint: entry.print === true,
        canMail: entry.mail === true,
    };


};
